// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual-check-container[data-v-16e75e1e]{display:flex;flex-direction:column;width:30%;justify-content:space-between}.manual-check-btn[data-v-16e75e1e]{min-height:unset;height:35px;width:100%;font-size:14px!important}.btn--size[data-v-16e75e1e]{width:16px!important;height:16px!important}.check-label[data-v-16e75e1e]{font-size:12px;line-height:1.33;letter-spacing:.32px}", ""]);
// Exports
module.exports = exports;
